import { useGet, usePost, usePut } from '../../../sharedModules/hooks/useQuery';
import {
  LabelPreviewResult,
  WarehouseLabelConfigPayload,
  warehouseLabelConfigsUrl,
  warehouseLabelPreviewUrl,
} from '../model';

export function useWarehouseLabelConfigs(location: string) {
  return useGet<WarehouseLabelConfigPayload>({
    url: warehouseLabelConfigsUrl,
    params: { location },
    enabled: !!location,
  });
}

// A save returns the whole payload, not just the saved template: assigning a department
// moves it out of another template, so two templates change on one write.
export function useSaveWarehouseLabelTemplate() {
  return usePut<WarehouseLabelConfigPayload>();
}

// A mutation rather than a query: each check is a live ServMan call the admin asks for, not
// data to cache and refetch.
export function useLabelPreview() {
  return usePost<LabelPreviewResult>();
}

export function labelPreviewVariables(poNumber: string, location: string) {
  return { url: warehouseLabelPreviewUrl, data: { po_number: poNumber, location } };
}
